import React from 'react';

import OrderServiceCarRegistrationData from 'components/layout/order/OrderServiceCarRegistrationData';
import OrderServiceCarInsuranceData from 'components/layout/order/OrderServiceCarInsuranceData';

class OrderServicesInfos extends React.Component {
  getData = service => {
    const { entity } = this.props;

    switch (service.getName()) {
      case 'carRegistration':
        return <OrderServiceCarRegistrationData service={service} entity={entity} />;

      case 'carInsurance':
        return <OrderServiceCarInsuranceData service={service} entity={entity} />;
    }
  };

  render() {
    const { entity } = this.props;

    let res = [];
    for (let i = 0; i < entity.getServices().length; i++) {
      const service = entity.getServices()[i];

      res.push(
        <div class={i + 1 === entity.getServices().length ? '' : 'm-b-15 '} key={i}>
          {this.getData(service)}
        </div>
      );
    }

    return res;
  }
}

export default OrderServicesInfos;
